import type { AdditionalSearchableFeature, SomeAdditionalSearchableFeature } from "../types";

export const makeAdditionalSearchableFeature = <S extends string>(
  i: AdditionalSearchableFeature<S>
): SomeAdditionalSearchableFeature => {
  return (cb) => cb(i);
};
